/* eslint-disable prettier */
/**
 * Ar resource file
 */
export const labels = {};

export const errors = {};